import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionZeppUpdateSettingsPayload,
	IActionZeppUpdateSettingsPayloadDone,
	IActionZeppUpdateSettingsPayloadError,
} from './types';

export const zeppUpdateSettings = actionCreatorAsync<
	IActionZeppUpdateSettingsPayload,
	IActionZeppUpdateSettingsPayloadDone,
	IActionZeppUpdateSettingsPayloadError
>(
	'zeppUpdateSettings',
	async (params) => {
		const { enabled, email, password } = params;
		const { data } = await Api.zepp.updateSettings({
			body: { enabled, email, password },
		});

		return data;
	},
);
